import {init as shopifyInit} from '../../services/Shopify';
import {WSProvider} from '../../providers/WebSocketProvider';
import {VideoProvider} from '../../providers/VideoProvider';
import VGRooms from './VGRooms';
import VGMenu from './VGMenu';
import Chat from '../../components/ChatCmp';
import {shopifyData} from './data';
import GACmp from "../../components/GACmp";

const TRACKING_ID = process.env.REACT_APP_GA4_TRACKING_ID;

const VGRouter = () => {
  shopifyInit({
    token: shopifyData.token,
    domain: shopifyData.domain,
    productIds: shopifyData.productIds,
  });
  return (
    <>
      <GACmp trackingIds={[TRACKING_ID]} />
      <VGRooms />
      <VGMenu />
      <WSProvider eventId='vg-room'>
        <VideoProvider>
          <Chat />
        </VideoProvider>
      </WSProvider>
      {shopifyData.productIds.map((productId, i) => (
        <div key={i} id={`product-component-${productId}`}></div>
      ))}
    </>
  );
};

export default VGRouter;
